<template>
  <q-dialog :model-value="modelValue" maximized @update:model-value="$emit('update:modelValue', $event)">
    <q-card>
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Данные таблицы (JSON)</div>
        <q-space />
        <q-btn
          v-if="actionType"
          :label="sendBtnLabel"
          color="deep-orange-7"
          no-caps dense
          icon="send"
          :loading="sending"
          class="q-mr-sm"
          @click="$emit('send')"
        />
        <q-btn icon="content_copy" flat round dense @click="copyJson" />
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>
      <q-card-section v-if="unsentCount > 0" class="q-pt-xs q-pb-none">
        <q-banner dense rounded class="bg-orange-1 text-orange-9" style="font-size:13px">
          <template #avatar><q-icon name="warning" color="orange-7" /></template>
          Среди выбранных <b>{{ unsentCount }}</b> {{ unsentCount === 1 ? 'неотправленная запись' : 'неотправленных записей' }} —
          {{ unsentCount === 1 ? 'она будет удалена' : 'они будут удалены' }} из БД без отправки в УСП.
        </q-banner>
      </q-card-section>
      <q-card-section>
        <pre class="json-pre">{{ content }}</pre>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'PpmJsonDialog',
  props: {
    modelValue: Boolean,
    content: { type: String, default: '' },
    actionType: { type: String, default: '' },
    sending: { type: Boolean, default: false },
    unsentCount: { type: Number, default: 0 },
  },
  emits: ['update:modelValue', 'send'],
  computed: {
    sendBtnLabel() {
      if (this.actionType === 'storno')         return 'Отправить сторно в УСП';
      if (this.actionType === 'storno_partial') return 'Отправить частичное сторно в УСП';
      if (this.actionType === 'send_smeta')     return 'Отправить смету в УСП';
      return 'Отправить в УСП';
    },
  },
  methods: {
    async copyJson() {
      try {
        await navigator.clipboard.writeText(this.content || '');
        this.$q?.notify?.({ type: 'positive', message: 'Скопировано' });
      } catch { /* ignore */ }
    },
  },
};
</script>
